﻿import * as React from "react";
import { DataFeedStatusTable } from "./DataFeedStatus";

export const DataFeedStatusRoot: React.FunctionComponent =
    (): React.ReactElement => (
        <div className={`datafeedstatus-rootcontainer`}>
            <div className={`datafeedstatus-header greybackground rounded`}>
                Data Feed Status
            </div>
            <div
                className={`greybackground rounded`}
                style={{ height: `100%` }}
            >
                <DataFeedStatusTable />
            </div>
        </div>
    );
